module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "gallery-viewer"
  }, [_c('section', {
    staticClass: "panel media-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ol', _vm._l((_vm.secondaryMedia), function(media, index) {
    return _c('li', {
      key: media.id,
      staticClass: "media-group"
    }, [_c('div', {
      staticClass: "media-wrapper"
    }, [(media.type === 'image') ? _c('img', {
      staticClass: "media",
      attrs: {
        "src": media.url
      },
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (media.type === 'video') ? _c('div', [(!media.iframeHtmlError) ? _c('div', {
      staticClass: "media media-iframe",
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(media.iframeHtml)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-iframe-spacer-16-9"
    })]) : _c('div', {
      staticClass: "media-error"
    }, [_c('p', [_vm._v("Error loading video")])])]) : _vm._e(), _vm._v(" "), (media.type === 'sketchfab') ? _c('div', [(!media.iframeHtmlError) ? _c('div', {
      staticClass: "media media-iframe",
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(media.iframeHtml)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-iframe-spacer-16-9"
    })]) : _c('div', {
      staticClass: "media-error"
    }, [_c('p', [_vm._v("Error loading Sketchfab")])])]) : _vm._e(), _vm._v(" "), (media.type === 'marmoset') ? _c('div', [_c('div', {
      staticClass: "media media-iframe"
    }, [_c('marmoset-viewer', {
      attrs: {
        "src": media.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-iframe-spacer-8-6"
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-buttons-wrapper"
    }, [(media.type === 'image') ? _c('div', {
      staticClass: "media-buttons"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": media.url
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "clear-button",
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-expand"
    })])]) : _vm._e()])]), _vm._v(" "), (!!media.caption) ? _c('div', {
      staticClass: "media-caption",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.escapeHtml(media.caption)))
      }
    }) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_c('section', {
    staticClass: "panel info-container"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._m(1), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'edit-gallery',
        params: {
          galleryId: _vm.id
        }
      }
    }
  }, [_vm._v("\n                    Edit\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.canEditHighlight) ? _c('div', {
    staticClass: "form-group recruiter-visibility"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.highlighted),
      expression: "highlighted"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.savingHighlight
    },
    domProps: {
      "checked": Array.isArray(_vm.highlighted) ? _vm._i(_vm.highlighted, null) > -1 : (_vm.highlighted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.highlighted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.highlighted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.highlighted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.highlighted = $$c
        }
      }
    }
  }), _vm._v("\n                        Visible to recruiters\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-author"
  }, [_vm._v("\n                    By\n                    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          author: _vm.author.id
        }
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.author.name) + "\n                    ")]), _vm._v(" "), (_vm.localStorage.roles.includes('Recruiter')) ? _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.author.email,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.author.email) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), (!!_vm.description) ? _c('p', {
    staticClass: "post-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.description))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-date"
  }, [_vm._v("\n                    Posted " + _vm._s(_vm.formatPostDate(_vm.createdAt)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-group gallery-stats"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatStatText('Like', 'Likes', _vm.likes.length)))]), _vm._v(" "), (!_vm.hasLikedGallery) ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittingLike
    },
    on: {
      "click": _vm.likeGallery
    }
  }, [_vm._v("\n                            Like\n                        ")]) : _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittingLike
    },
    on: {
      "click": _vm.unlikeGallery
    }
  }, [_vm._v("\n                            Unlike\n                        ")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatStatText('View', 'Views', _vm.viewCount)))])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatStatText('Comment', 'Comments', _vm.commentCount)))])])]), _vm._v(" "), (_vm.term || _vm.path || _vm.groups.length > 0 || _vm.assignment) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Categories")]), _vm._v(" "), (!!_vm.term) ? _c('div', {
    staticClass: "category"
  }, [_c('div', [_vm._v("Term")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          term: '' + _vm.term.id
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.term.name) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (!!_vm.path && _vm.path.id != 9200) ? _c('div', {
    staticClass: "category"
  }, [_c('div', [_vm._v("Path")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          path: '' + _vm.path.id
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.path.name) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.groups.length > 0) ? _c('div', {
    staticClass: "category"
  }, [(_vm.groups.length > 1) ? _c('div', [_vm._v("Groups")]) : _c('div', [_vm._v("Group")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('router-link', {
      key: group.id,
      attrs: {
        "to": {
          name: 'galleries',
          query: {
            group: '' + group.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(group.label) + "\n                        ")])
  })], 2) : _vm._e(), _vm._v(" "), (!!_vm.assignment) ? _c('div', {
    staticClass: "category"
  }, [_c('div', [_vm._v("Assignment")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          assignment: '' + _vm.assignment.id
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.assignment.name) + "\n                        ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.softwareUsed.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Software Used")]), _vm._v(" "), _c('software-list', {
    attrs: {
      "value": _vm.linkedSoftwareUsed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.moreGalleries.length > 0) ? _c('div', {
    staticClass: "info-group more-by"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_c('span', [_vm._v("More by")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          author: _vm.author.id
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.author.name) + "\n                        ")])], 1), _vm._v(" "), _c('gallery-grid', {
    attrs: {
      "gutter-width": 10,
      "count-per-row": 3,
      "galleries": _vm.moreGalleries
    },
    on: {
      "click": _vm.onAuthorGalleryClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tags.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('tag-list', {
    attrs: {
      "value": _vm.linkedTags
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "panel comments-container"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v("\n                    " + _vm._s(_vm.formatCommentsText(_vm.commentCount)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ol', _vm._l((_vm.comments), function(comment) {
    return _c('li', {
      key: comment.id
    }, [_c('gallery-comment', {
      staticClass: "comment",
      attrs: {
        "comment": comment
      },
      on: {
        "like": _vm.likeComment,
        "unlike": _vm.unlikeComment,
        "edit": _vm.editComment,
        "reply": _vm.addCommentReply,
        "delete": _vm.deleteComment,
        "focus": _vm.addCommentReplyFocus,
        "blur": _vm.addCommentReplyBlur
      }
    })], 1)
  })), _vm._v(" "), _c('gallery-comment-form', {
    attrs: {
      "placeholder": "Add a comment..."
    },
    on: {
      "submit": _vm.addComment,
      "focus": _vm.addCommentReplyFocus,
      "blur": _vm.addCommentReplyBlur
    }
  })], 1)])]), _vm._v(" "), (_vm.lightbox.media.length > 0) ? _c('LightboxMediaGallery', {
    attrs: {
      "media": _vm.lightbox.media,
      "index": _vm.lightbox.index,
      "showing": _vm.lightbox.showing,
      "can-slide-past-first": true,
      "can-slide-past-last": true
    },
    on: {
      "update:index": function($event) {
        _vm.lightbox.index = $event
      },
      "update:showing": function($event) {
        _vm.lightbox.showing = $event
      },
      "slide-past-first": function($event) {
        _vm.goToLeftGallery()
      },
      "slide-past-last": function($event) {
        _vm.goToRightGallery()
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "gallery-viewer"
  }, [_vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v("\n                Media\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                    Details\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel loading-container"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n            Loading\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0624b54a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryViewer.vue
// module id = 1965
// module chunks = 2